import React from 'react';
import PropTypes from 'prop-types';
import { Button, Link } from '@sparefoot/react-core';
import { overwriteDisplayName } from '@sparefoot/react-core/tracking-lib';
import classnames from 'classnames';

import './Button.scss';
import '../Link/Link.scss';
import { withClickTracking } from 'components/core/library/tracking-utils';

export const enhance = (Component) => {
	const EnhancedButton = (props) => {
		const {
			className,
			fullWidth,
			primary,
			secondary,
			tertiary,
			link,
			underline,
			centered,
			href,
			to,
			...rest
		} = props;

		const enhancedClassName = classnames(
			className,
			link
				? {
						'ss-link': link,
						'ss-link-secondary': secondary,
						'ss-link-underline': underline,
					}
				: {
						'ss-button': primary || secondary || tertiary,
						'ss-button-primary': primary,
						'ss-button-secondary': secondary && !primary,
						'ss-button-full': fullWidth,
						'ss-button-tertiary':
							tertiary && !primary && !secondary,
						'ss-button-centered': centered,
					},
		);

		const mergedProps = {
			...rest,
			className: enhancedClassName,
			isButton: true,
			primary,
			secondary,
			tertiary,
			link,
			underline,
			fullWidth,
			centered,
			href,
			to,
		};

		if (href || to) {
			if (mergedProps.target === '_blank' && !mergedProps.rel) {
				const dest = mergedProps.href || mergedProps.to || '';
				const isRelative = dest.startsWith('/') || dest.startsWith('#');
				mergedProps.rel = isRelative
					? 'noopener'
					: 'noopener noreferrer';
			}
			return <Link {...mergedProps} />;
		}

		return <Component {...mergedProps} />;
	};
	EnhancedButton.propTypes = {
		className: PropTypes.string,
		fullWidth: PropTypes.bool,
		primary: PropTypes.bool,
		secondary: PropTypes.bool,
		tertiary: PropTypes.bool,
		link: PropTypes.bool,
		underline: PropTypes.bool,
		centered: PropTypes.bool,
		href: PropTypes.string,
		to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	};
	return overwriteDisplayName('Button')(EnhancedButton);
};

export default withClickTracking(enhance(Button));
